import {_showClearIcon, _dropCommonHtml} from "./Common_Fun";

import {AssertUtils,GoingUtils,ArrayUtils} from "goingutils";
import EditorTypeUtils from "../../../common/editorTypeUtils";


let _setInputVals = function (
    inputId,
    treeRelId,
    {labels = "", values = ""}
) {
    $(`#${inputId}`).val(labels);
    if (AssertUtils.isNotNull(treeRelId)) {
        $(`#${inputId}`)
            .prev()
            .val(values);
    }
};
let _getMultipleSels = function (containerObj) {
    let selCoding = [];
    let selCodingName = [];
    containerObj.find(".multiple-item.sel-item").each(function () {

        selCoding.push($(this).attr("coding"));

        selCodingName.push($(this).attr("name"));
    });
    return {selCoding, selCodingName};
};
let GoMultipDrop = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        return this.getEditorHtml(item, targetObj);
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(
            item,
            targetObj,
            "go-ctl-multiple-drop",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果编数据下拉
        backJson[item["id"]] = $("#" + inputElId).val();
        //如果树存在关联字段
        if (AssertUtils.isNotNull(item["treeRelId"])) {
            backJson[item["treeRelId"]] = $(
                `#${targetObj.prefixCls}_${item["treeRelId"]}`
            ).val();
        }
    },
    getDropContainerHtml(inputId, inputWidth, itemObj) {
        //获取子项集合
        function _getSonItems(items) {
            let sonHtmls = [];
            if (items != null) {
                items.forEach(function ({value, label}) {
                    sonHtmls.push(`<div @click="selItem(item,$event)" coding="${value}"  name="${label}" 
                                                class="go-drop-item multiple-item flex-space-between">
                                              <div class="label">${label}</div><div class="check-img"><i class="fas fa-check"></i></div>
                        </div>`);
                });
                return sonHtmls.join("");
            }
        }

        let html = `<div style="position: absolute; top: 0px; left: 0px; width: 100%;">
                            <div>
                                <div  id="${inputId}_multiple_drop" inputId="${inputId}"  class="go-common-drop" style="max-height: 400px;padding-bottom: 8px; overflow: auto; width: ${inputWidth +
        ""}px;">
                                     <div class="search-bar margin-t-5" v-if="search" style="padding-top: 0">
                                            <div class="input-icon right" style="border-radius:0;">
                                            <i class="fas fa-search"></i>
                                            <input :id="searchId" type="text" class="form-control" placeholder="输入筛选"> </div>
                                        </div>
                                      <div class="drop-btn-bar">
                                         <div class="flex-center">
                                            <div class="drop-btn col-sm-6" id="${inputId}_sellAll">全选</div>
                                            <div id="${inputId}_clearAll" class="drop-btn col-sm-6">取消选择</div></div>
                                     </div>
                                    <div  class="search-body">
                                         ${_getSonItems(itemObj["items"])}
                                    </div>
                                </div>
                            </div>
                        </div>`;
        return html;
    },
    /***
     * 初始化缺省的控件相关事件
     * @param inputId
     * @param itemObj
     */
    initDefaultEvent(inputId) {
        //点击输入框 弹出下拉选择数据
        $(`#${inputId}`).click(function () {
            let {x, y} = GoingUtils.getElementPosition($(this).get(0));
            //设置显示的下拉位置
            $(`#${inputId}_multiple_drop`)
                .show()
                .css("left", x)
                .css(
                    "top",
                    y +
                    2 +
                    parseFloat(
                        $(this)
                            .closest(".input-group")
                            .css("height")
                    )
                );
            let inputVals = $(this).val();
            let selItems = [];
            if (AssertUtils.isNotEmpty(inputVals)) {
                selItems = (inputVals + "").split(GoingUtils.relChart);
            }

            $(`#${inputId}_multiple_drop`)
                .find(".multiple-item")
                .each(function () {
                    let curItemName = $(this).attr("name");
                    if (ArrayUtils.aryContains(selItems, curItemName)) {
                        $(this).addClass("sel-item");
                    } else {
                        $(this).removeClass("sel-item");
                    }
                });
        });

        //选择下拉子项信息 填写数据
        $(`#${inputId}_multiple_drop .multiple-item`).click(function () {
            $(this).toggleClass("sel-item");

            //获取选择的值
            let {selCoding, selCodingName} = _getMultipleSels(
                $(this).closest(".go-common-drop")
            );

            let _inputId = $(this)
                .closest(".go-common-drop")
                .attr("inputId");
            let treeRelId = $(`#${_inputId}`).attr("treeRelId");
            _setInputVals(_inputId, treeRelId, {
                labels: selCodingName.join(GoingUtils.relChart),
                values: selCoding.join(GoingUtils.relChart)
            });

            _showClearIcon(inputId);
        });

        //点击取消按钮
        $(`#${inputId}_clearAll`).click(function () {
            $(this)
                .closest(".go-common-drop")
                .attr("inputId");
            let treeRelId = $(`#${inputId}`).attr("treeRelId");
            //取消所有项的选中状态
            $(this)
                .closest(".go-common-drop")
                .find(".sel-item")
                .removeClass("sel-item");
            //设置为空
            _setInputVals(inputId, treeRelId, {});
        });

        //点击选择所有记录按钮
        $(`#${inputId}_sellAll`).click(function () {
            //选中相应的子项
            $(this)
                .closest(".go-common-drop")
                .find(".multiple-item")
                .each(function () {
                    $(this).addClass("sel-item");
                });
            //获取多选的值
            let {selCoding, selCodingName} = _getMultipleSels(
                $(this).closest(".go-common-drop")
            );
            let _inputId = $(this)
                .closest(".go-common-drop")
                .attr("inputId");
            let treeRelId = $(`#${_inputId}`).attr("treeRelId");
            _setInputVals(_inputId, treeRelId, {
                labels: selCodingName.join(GoingUtils.relChart),
                values: selCoding.join(GoingUtils.relChart)
            });
            //显示清空图标
            _showClearIcon(_inputId);
        });

        //如果点击的不是控件本身 则隐藏
        $(document).click(function (e) {
            let target = $(e.target);
            if (
                !target.is("#" + inputId + " *") &&
                !target.is("#" + inputId) &&
                !target.is(`#${inputId}_multiple_drop *`) &&
                !target.is(`.dhxtreeview_icon`)
            ) {
                $(`#${inputId}_multiple_drop`).hide();
            }
        });
    },
    getRealValue(value) {
        return value || " ";
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    initCtlEvent: function (parentObj, inputWidth) {
        $(parentObj)
            .find(".go-ctl-multiple-drop")
            .each(function () {
                let inputId = $(this).attr("id");
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];

                //如果声明了
                let ctl = $(this).attr("ctl");
                if (ctl === "auto") {
                    let inputId = $(this).attr("id");
                    let html = GoMultipDrop.getDropContainerHtml(
                        inputId,
                        inputWidth,
                        itemObj
                    );
                    $(html).appendTo($("#main_router_view"));
                    GoMultipDrop.initDefaultEvent(inputId, itemObj);
                }
            });
    }
};

export default GoMultipDrop;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-multip-drop.js